export const STORE_EMAIL_REGISTRATION = 'STORE_EMAIL_REGISTRATION'
export const STORE_OAUTH_PROVIDER = 'STORE_OAUTH_PROVIDER'
export const STORE_ACTION_AFTER_LOGIN = 'STORE_ACTION_AFTER_LOGIN'
export const UPDATE_PASSWORD_TYPE = 'UPDATE_PASSWORD_TYPE'
